'use client'

import { usePathname } from 'next/navigation'
import { DEFAULT_LANGUAGE } from '~/data/language'

export function useLocalizedNavigation() {
  const pathname = usePathname()
  const currentLocale = pathname.split('/')[1] || DEFAULT_LANGUAGE
  const homePageUrl = process.env.NEXT_PUBLIC_PORTAL_URL || ''

  const getLocalizedHref = (href: string) => {
    // If href is external (starts with http or https), return as is
    if (href.startsWith('http')) {
      return href
    }

    // If href is anchor link (#), return as is
    if (href.startsWith('#')) {
      return href
    }

    // If href already starts with locale, return as is
    if (href.startsWith(`/${currentLocale}/`)) {
      return href
    }

    // If href starts with /, add locale
    if (href.startsWith('/')) {
      return `/${currentLocale}${href}`
    }

    // Default case: add locale with /
    return `/${currentLocale}/${href}`
  }

  const getFullUrl = (href: string) => {
    // If href is external (starts with http or https), return as is
    if (href.startsWith('http')) {
      return href
    }

    // If href is anchor link (#), return as is
    if (href.startsWith('#')) {
      return href
    }

    // Add homepage prefix to the localized href
    const localizedHref = getLocalizedHref(href)
    return `${homePageUrl}${localizedHref}`
  }

  return {
    currentLocale,
    getLocalizedHref,
    getFullUrl,
  }
}
